export default __webpack_public_path__ + "static/media/codepen.c96545a1.webp";